import { render, staticRenderFns } from "./MapEntityModal.vue?vue&type=template&id=39ec8c71&scoped=true&"
import script from "./MapEntityModal.vue?vue&type=script&lang=ts&"
export * from "./MapEntityModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec8c71",
  null
  
)

export default component.exports